module.exports = __webpack_public_path__ + "assets/devices/Smart-Smoke-Heat-b5bb83094745554e8835549f1d1056cd.svg";